import { React } from 'libs/react';
import classNames from 'classnames';
import { Money } from 'components/Money';
import i18n from 'components/translation/i18n';
import './DealItemDiscountedPrice.scss';
/**
 * Prix d'une ligne de la soumission interactive. Quand le rabais est affiché
 * et que le prix est sous le prix catalogue, le prix catalogue est barré et
 * le pourcentage de rabais est mentionné.
 * @component DealItemDiscountedPrice
 * @since 1.0.0
 */
export function DealItemDiscountedPrice(props) {
    const { value, listPrice, showDiscount, className } = props;
    const roundedValue = Math.round(value * 100);
    const roundedListPrice = Math.round(listPrice * 100);
    if (!showDiscount ||
        roundedListPrice <= 0 ||
        roundedValue >= roundedListPrice) {
        return React.createElement(Money, { className: className, value: value });
    }
    const percent = ((listPrice - value) / listPrice) * 100;
    return (React.createElement("span", { className: "deal-item-discounted-price" },
        React.createElement("span", { className: "deal-item-discounted-price__prices" },
            React.createElement(Money, { className: classNames(className, 'deal-item-discounted-price__original'), value: listPrice }),
            React.createElement(Money, { className: className, value: value })),
        React.createElement("span", { className: "deal-item-discounted-price__mention" },
            t('Rebate'),
            ' ',
            percent.toLocaleString(i18n.language, { maximumFractionDigits: 1 }),
            ' %')));
}
